export default __webpack_public_path__ + "static/media/Boys_Snooze.7807785e.svg";